
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M11.59 4c.219 0 .43.073.602.204l.098.086 1.42 1.42a1 1 0 00.57.281l.13.009H20c1.054 0 1.918.816 1.995 1.85L22 8v10a2.001 2.001 0 01-1.85 1.995L20 20H4a2.001 2.001 0 01-1.995-1.85L2 18V6c0-1.054.816-1.918 1.85-1.995L4 4h7.59zm.49 4h-.16l-.005.695c-.056 3.741-.673 4.209-4.676 4.225H7v.16l.695.004c3.74.056 4.208.674 4.225 4.677V18h.16l.004-.695c.056-3.741.674-4.209 4.677-4.225H17v-.16l-.695-.004c-3.742-.056-4.209-.674-4.225-4.677V8z"}})])
          )
        }
      }
    